import './style.scss';
import { UnitInput, UnitInputPosition, UnitInputProps } from '../unitInput';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { MultiSelections, Direction, MultiSelectionsProps } from 'views/mutual/inputRadio';
import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
import { MessageModal } from 'views/mutual/modal/messageModal';
import { BankModal } from 'views/templates/module/bankDetailsInput/modal';
import { ModalSpacing } from 'views/mutual/modal';
import { FormError } from 'views/mutual/formErrorScroll';
import { AccountType } from './hooks';

export type BankDetailsInputType = {
  name: string;
} & BankDetailsInputDataType;

export type BankDetailsInputDataType = {
  selectBankProps: {
    selected: string;
    onSelectedBank: (value: string) => void;
    error?: string | undefined;
  };
  selectBranchProps: {
    selected: string;
    onSelectedBranch: (value: string) => void;
    error?: string | undefined;
  };
  accountTypeProps: MultiSelectionsProps;
  accountNumberProps: UnitInputProps;
  accountHolderNameProps: UnitInputProps;
};

export const BankDetailsInput = (props: BankDetailsInputType) => {
  const { modalProps, showMessageModalWithoutButton, showMessageModal } = useMessageModal();
  return (
    <>
      <div className="bankDetailsInput">
        <div className="bankDetailsInput_wrapper">
          <div className={`bankDetailsInput_wrapper_label`}>{'金融機関名'}</div>
          <FormError className="bankDetailsInput_wrapper_error" error={props.selectBankProps.error} />
          <div className={`bankDetailsInput_wrapper_inputColumn`}>
            {props.selectBankProps.selected && (
              <div className={`bankDetailsInput_wrapper_label`}>{props.selectBankProps.selected}</div>
            )}
            <Button
              label={'金融機関を検索する'}
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.small}
              onClick={() => {
                showMessageModal(
                  <BankModal
                    onClosed={() => modalProps.setIsOpen(false)}
                    onSelectedBank={(value: string) => {
                      props.selectBankProps.onSelectedBank?.(value);
                    }}
                    onSelectedBranch={(value: string) => {
                      props.selectBranchProps.onSelectedBranch?.(value);
                    }}
                  />,
                  () => {
                    props.selectBankProps.onSelectedBank?.('');
                    props.selectBranchProps.onSelectedBranch?.('');
                  },
                  'キャンセル',
                  'bankModal_cancelButton',
                );
              }}
            />
            <MessageModal {...modalProps} spacing={ModalSpacing.small} shouldCloseOnOverlayClick={false}></MessageModal>
          </div>
        </div>

        <div className="bankDetailsInput_wrapper">
          <div className={`bankDetailsInput_wrapper_label`}>{'支店名'}</div>
          <FormError className="bankDetailsInput_wrapper_error" error={props.selectBranchProps.error} />
          <div className={`bankDetailsInput_wrapper_inputColumn`}>
            <div className={`bankDetailsInput_wrapper_label`}>{props.selectBranchProps.selected}</div>
          </div>
        </div>

        <div className="bankDetailsInput_wrapper">
          <div className={`bankDetailsInput_wrapper_label`}>{'預金種別'}</div>
          <div className={`bankDetailsInput_wrapper_inputColumn`}>
            <MultiSelections
              {...props.accountTypeProps}
              direction={Direction.row}
              items={[
                { label: '普通', value: AccountType.Ordinary },
                { label: '当座', value: AccountType.Checking },
                { label: '貯蓄', value: AccountType.Savings },
                { label: 'その他', value: AccountType.Other },
              ]}
              name="accountType"
            />
          </div>
        </div>

        <UnitInput
          {...props.accountNumberProps}
          placeholder="半角数字7桁"
          maxLength={7}
          label="口座番号"
          unit={UnitInputPosition.before}
        />

        <UnitInput
          {...props.accountHolderNameProps}
          placeholder="例：トウキョウ　タロウ"
          label="口座名義"
          unit={UnitInputPosition.before}
        />
        <div className='bankDetailsInput_wrapper_label'>{'※ご契約者名と同じ口座名義のみのお取り扱いとなります。'}</div>
      </div>
    </>
  );
};
